import * as types from './mutation-types'

export default {
  [types.ADD_MOVEMENTS](state, data) {
    state.movements = data
  },
  [types.ADD_TYPE_REASONS](state, data) {
    state.typeReasons = data.reasons
  },
  [types.LOAD_MOVEMENT_LINE_STATUS](state, data) {
    state.movementLineStatus = data
  },
  [types.LOAD_MOVEMENT_STATUS](state, data) {
    state.movementStatus = data
  },
}
